const currencyMap = {
  BRL: { symbol: 'R$', locale: 'pt-BR', code: 'BRL' },
  USD: { symbol: '$', locale: 'en-US', code: 'USD' },
  EUR: { symbol: '\u20ac', locale: 'de-DE', code: 'EUR' },
};

export function getCurrency(user) {
  return currencyMap[user?.currency] || currencyMap.BRL;
}

export function formatMoney(value, user) {
  const { locale, code } = getCurrency(user);
  return parseFloat(value).toLocaleString(locale, {
    style: 'currency',
    currency: code,
  });
}
